import { render, staticRenderFns } from "./ResizeContainer.vue?vue&type=template&id=4306f91c&"
import script from "./ResizeContainer.vue?vue&type=script&lang=js&"
export * from "./ResizeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports